var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "password-requirements-container" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm.hide
        ? _c("f9button", { on: { click: _vm.hide } }, [
            _vm._v("RETURN TO SIGN UP")
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [
        _vm._v(
          "Password must be between 8 and 16 characters long and must include:"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", { staticClass: "checkmark-gray" }, [
        _vm._v(" One uppercase letter")
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "checkmark-gray" }, [
        _vm._v(" One lowercase letter")
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "checkmark-gray" }, [_vm._v(" One number")]),
      _vm._v(" "),
      _c("li", { staticClass: "checkmark-gray" }, [
        _vm._v(" One special character")
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "xmark-gray" }, [
        _vm._v(
          " Cannot contain period (.) comma (,) tilde (~) or underscore (_)"
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dcf6639", { render: render, staticRenderFns: staticRenderFns })
  }
}